module.exports = __webpack_public_path__ + "static/meta-image-protrans-A-8b380a694687cd9c93808b1b69a7f3ce.png";